module.exports = __webpack_public_path__ + "static/media/sending-application-banner.5204c916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sending-application-banner.png
// module id = 2612
// module chunks = 1